
import TrendDown from "../../../assets/outline/TrendDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TrendDownIcon({ className, dataTestid = "TrendDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TrendDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
